import { Preferences } from '@capacitor/preferences'
import { useEffect, useState } from 'react'
import { atom, useRecoilState } from 'recoil'

import { capacitorPreferencesEffect } from '@/capacitor/recoil/capacitor-preferences-effect'

import type { TenantSlug } from '@/modules/healthblocks/ServerProvider'

const STORAGE_KEY = '@app/persistedTenant'

export const persistedTenantAtom = atom<TenantSlug | null>({
  key: 'persistedTenant',
  default: null,
  effects: [capacitorPreferencesEffect(STORAGE_KEY)],
})

let hydrated = false

/**
 * Hook to get and set the persisted tenant
 */
export function usePersistedTenant() {
  const [persistedTenant, setPersistedTenant] = useRecoilState(persistedTenantAtom)
  const [isHydrated, setIsHydrated] = useState(hydrated)

  useEffect(() => {
    if (hydrated) return
    let cancelled = false

    Preferences.get({ key: STORAGE_KEY }).then(({ value }) => {
      if (cancelled) return
      if (value !== null) {
        try {
          setPersistedTenant(JSON.parse(value) as TenantSlug)
        } catch {
          /* corrupted value — leave atom at default */
        }
      }
      hydrated = true
      setIsHydrated(true)
    })

    return () => {
      cancelled = true
    }
  }, [setPersistedTenant])

  return {
    persistedTenant,
    setPersistedTenant,
    isHydrated,
  }
}
